<template>
	<div id="notice">
		<el-dialog
		  title=""
		  :visible.sync="showDialog"
		  :append-to-body="true"
		  :show-close="true"
		  width="800px"
		  top='20vh'
		  :before-close="closeLogin">

		  <div class="head">
			  <div class="noticeTitle">{{$t('indexPage.notice')}}</div>
			  <!-- <span class="infoIcon closeImg" @click="closeLogin" >&#xe607</span> -->
		  </div>

		  <div class="dlgnotice" style="overflow:auto; height:400px; width:790px; margin: 0 auto;padding-bottom:20px;" v-loading="loading">
				<ul class="mainContent">
					<li v-for="(item,index) in list" :key = "index" >
						<div class="item">
							<div class="content1"><span>{{item.subject}}</span>
							
							<p style="font-size:14px;margin-top:5px;text-indent: 2em;line-height: 24px;color: #707070;font-size: 12px;padding: 6px 0;">{{item.content}}</p>
							</div>
						</div>

					</li>
				</ul>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			list: []
		},
	  data() {
	    return {
			isClickLogin: true, //只有第一次登录生效，除非登录失败
			code: '',
			showDialog: false,
			// list: [],
			loading:false,
	    };
	  },

	  mounted() {
		//   this.getNotices();
	  },

	  methods: {
          
		  closeLogin() {
            this.showDialog = false;
		  },
		  async getNotices() {
			this.loading = true;
		    var _this = this;
		    var data = {
		      createdAt: '',
		      currentPage: '',
		      pageSize: '',
		      publishedAt: '',
		      subject: '',
		      type: ''
		    };
		    var res = await _this.$http.post(_this.$api.noticeList, data);
		    if (res.code == 0) {
		  	  _this.list = res.data.content;
		    } else {
		      this.$message.error(res.msg);
			}
			_this.loading = false;
		  }
	  }
	};
</script>
<style scoped>
	>>> .el-dialog__headerbtn {
		right: 20px;
		top: 20px;
	}
	>>> .el-dialog__headerbtn .el-dialog__close {
		color:white;
		transition:all 1s;
		transform:scale(2);
	}
	>>> .el-dialog__headerbtn .el-dialog__close:hover {
		transform:rotate(-180deg) scale(2);
	}
</style>
<style scoped>
	.el-dialog {
	  background: rgba(255,255,255,0);
	  /* border: none; */
			/* box-shadow: none; */
			/* border-radius: 10px; */
	}
	/deep/.el-dialog__body {
			  padding: 0px;
			  border-radius: 10px;
			  padding-bottom: 15px;
	}
	/deep/.el-dialog__header {
			  padding: 0px;
			  height: 0px;
	}
	.closeImg {
		margin-right: 10px;
		width: 24px;
		height: 24px;
        cursor: pointer;
	}
	.head{
		background-color: #ed2d2d;
		height: 55px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding-left: 10px;
		color: #FFFFFF;
		font-weight: 500;
		margin-bottom: 15px;
	}
	.noticeTitle {
		width: 100%;
		text-align: center;
		font-size:20px;
	}
	.item {
		border-bottom: 1px dashed #ccc;
		margin-left: 30px;
		margin-right: 30px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		font-size: 16px;
		padding-top: 10px;
		padding-bottom: 10px;
		padding: 10px 20px;
		margin: 10px 20px 25px;
		background: #f5f5f5;
		border-radius: 4px;
		border: 1px solid #e6e6e6;
	}
	.content {

	}
	.content1 {
		line-height: 32px;
		font-size: 15px;
		font-weight: 500;
		color: #333;
	}
	.infoIcon {
		width: 20px;height: 20px;
		font-family: "iconfont" !important;
		  font-size: 16px;
		  font-style: normal;
		  -webkit-font-smoothing: antialiased;
		  -moz-osx-font-smoothing: grayscale;
	}
</style>
